<div class="card shadow-sm border-0 overflow-hidden">
	<div class="card-header bg-accent text-white">
		<strong>واجهة إدخال البيانات - بيانات غير مطابقة للواقع</strong>
	</div>
	<div class="card-body">
		<div *ngIf="errorMsg" class="alert alert-danger d-flex align-items-center" role="alert">
			<i class="bi bi-exclamation-triangle-fill me-2"></i>
			<div>{{errorMsg}}</div>
		</div>
		<div *ngIf="isLoading" class="text-center my-4">
			<div class="spinner-border text-primary" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
			<div class="mt-2 text-muted">جاري التحميل...</div>
		</div>
		<form (ngSubmit)="onSubmit()" #f="ngForm">
			<div class="wizard-steps">
				<div class="wizard-step clickable" [class.active]="step===1" (click)="goTo(1)">
					<span class="num">1</span> بيانات التعريف
				</div>
				<div class="wizard-step clickable" [class.active]="step===2" (click)="goTo(2)">
					<span class="num">2</span> تفاصيل الحالة
				</div>
				<div class="wizard-step clickable" [class.active]="step===3" (click)="goTo(3)">
					<span class="num">3</span> المالية والمرفقات
				</div>
			</div>
			<div class="progress" role="progressbar" aria-label="Progress" aria-valuemin="0" aria-valuemax="100">
				<div class="progress-bar progress-bar-accent" [style.width.%]="stepProgress"></div>
			</div>

			<div class="row g-3" *ngIf="step===1">
				<div class="col-md-4">
					<label class="form-label required">رقم وطني لرب الأسرة</label>
					<div class="input-group">
						<span class="input-group-text"><i class="bi bi-person-vcard"></i></span>
						<input class="form-control" name="headNationalId" [(ngModel)]="model.headNationalId" required maxlength="12" placeholder="أدخل الرقم الوطني">
					</div>
				</div>
				<div class="col-md-4">
					<label class="form-label required">رقم وطني لفرد من الأسرة</label>
					<div class="input-group">
						<span class="input-group-text"><i class="bi bi-person"></i></span>
						<input class="form-control" name="memberNationalId" [(ngModel)]="model.memberNationalId" required maxlength="12" placeholder="أدخل الرقم الوطني للفرد">
					</div>
				</div>
				<div class="col-md-4">
					<label class="form-label required">رقم القيد</label>
					<div class="input-group">
						<span class="input-group-text"><i class="bi bi-hash"></i></span>
						<input class="form-control" name="registryNumber" [(ngModel)]="model.registryNumber" required placeholder="أدخل رقم القيد">
					</div>
				</div>
			</div>

			<div class="row g-3" *ngIf="step===2">
				<div class="col-md-4">
					<label class="form-label required">اسم الأب الثلاثي</label>
					<input class="form-control" name="fatherFullName" [(ngModel)]="model.fatherFullName" required>
				</div>
				<div class="col-md-4">
					<label class="form-label required">اسم المعني الثلاثي</label>
					<input class="form-control" name="subjectFullName" [(ngModel)]="model.subjectFullName" required>
				</div>
				<div class="col-md-4">
					<label class="form-label required">نوع الحالة</label>
					<select class="form-select" name="caseType" [(ngModel)]="model.caseType" required>
						<option value="">اختر...</option>
						<option value="بيانات غير مطابقة للواقع">بيانات غير مطابقة للواقع</option>
						<option value="متوفي">متوفي</option>
						<option value="فرد ليس من العائلة">فرد ليس من العائلة</option>
						<option value="متزوجة ومضافة">متزوجة ومضافة</option>
						<option value="الادخل">الادخل</option>
					</select>
				</div>
				<div class="col-12">
					<label class="form-label required">شرح الحالة</label>
					<textarea class="form-control" name="caseDescription" [(ngModel)]="model.caseDescription" rows="3" required></textarea>
				</div>
			</div>

			<div class="row g-3" *ngIf="step===3">
				<div class="col-md-3">
					<label class="form-label required">التاريخ</label>
					<input type="date" class="form-control" name="caseDate" [(ngModel)]="model.caseDate" required>
				</div>
				<div class="col-md-3">
					<label class="form-label required">قيمة مراد ترجيعها بالدولار</label>
					<input type="number" class="form-control" name="amountUsd" [(ngModel)]="model.amountUsd" min="0" step="0.01" required>
				</div>
				<div class="col-md-3">
					<label class="form-label required">عدد المنح</label>
					<input type="number" class="form-control" name="grantsCount" [(ngModel)]="model.grantsCount" min="0" step="1" required>
				</div>
				<div class="col-md-9">
					<label class="form-label">صورة مرفقة (مسح/تحميل)</label>
					<div class="d-flex align-items-center gap-2">
						<input type="file" accept="image/*" class="form-control" (change)="onFileChange($event)">
						<button type="button" class="btn btn-outline-secondary" (click)="scanFromScanner()" title="المسح عبر الماسح أو الكاميرا">
							<i class="bi bi-scanner"></i> مسح
						</button>
						<button type="button" class="btn btn-outline-primary" (click)="showCamera=true">
							<i class="bi bi-camera"></i> مسح بالكاميرا (مجاني)
						</button>
						<small class="text-muted">المسح يتطلب جهاز مدعوم. حالياً يتم استخدام اختيار ملف كبديل.</small>
					</div>
					<div class="mt-3" *ngIf="imagePreviewUrl">
						<label class="form-label">معاينة الصورة</label>
						<div>
							<img [src]="imagePreviewUrl" class="image-preview" alt="معاينة" />
						</div>
					</div>
					<div class="mt-3" *ngIf="showCamera">
						<app-camera-scanner (captured)="onCameraCaptured($event)" (closed)="onCameraClosed()"></app-camera-scanner>
					</div>
				</div>
			</div>

			<div class="wizard-actions mt-3">
				<button type="button" class="btn btn-outline-secondary" (click)="prev()" [disabled]="step===1">
					<i class="bi bi-arrow-right"></i> السابق
				</button>
				<div class="ms-auto"></div>
				<button type="button" class="btn btn-primary" *ngIf="step<3" (click)="next()">
					التالي <i class="bi bi-arrow-left"></i>
				</button>
				<button type="submit" class="btn btn-success" *ngIf="step===3 && !isEditing">
					<i class="bi bi-plus-lg"></i> إضافة
				</button>
				<button type="submit" class="btn btn-primary" *ngIf="step===3 && isEditing">
					<i class="bi bi-save"></i> حفظ التعديلات
				</button>
				<button type="button" class="btn btn-secondary" *ngIf="isEditing" (click)="cancel()">
					<i class="bi bi-x-circle"></i> إلغاء
				</button>
				<button type="reset" class="btn btn-outline-warning" (click)="reset()">
					<i class="bi bi-arrow-counterclockwise"></i> تفريغ الحقول
				</button>
			</div>
		</form>
	</div>
</div>

<div class="card shadow-sm mt-4 border-0">
	<div class="card-header bg-light">
		<strong>السجلات</strong>
	</div>
	<div class="card-body">
			<div class="row g-3 mb-3 align-items-center">
			<div class="col-auto">
				<span class="badge bg-primary-subtle text-primary border border-primary px-3 py-2 rounded-pill">
					<i class="bi bi-list-ul ms-1"></i> عدد السجلات: {{items.length}}
				</span>
			</div>
			<div class="col-auto">
				<span class="badge bg-secondary-subtle text-secondary border border-secondary px-3 py-2 rounded-pill">
					<i class="bi bi-calendar3 ms-1"></i> اليوم: {{ currentDate | date:'yyyy/MM/dd' }}
				</span>
			</div>
				<div class="col-md-4 ms-auto">
					<div class="input-group">
						<span class="input-group-text"><i class="bi bi-search"></i></span>
						<input type="text" class="form-control" [(ngModel)]="searchTerm" name="searchTerm" placeholder="بحث عن رب الأسرة، فرد، اسم، حالة..." aria-label="بحث">
					</div>
				</div>
				<div class="col-md-5">
					<div class="row g-2">
						<div class="col-md-6">
							<div class="input-group">
								<span class="input-group-text"><i class="bi bi-calendar-date"></i></span>
								<input type="date" class="form-control" [(ngModel)]="fromDate" name="fromDate" aria-label="من تاريخ">
							</div>
						</div>
						<div class="col-md-6">
							<div class="input-group">
								<span class="input-group-text"><i class="bi bi-calendar-date"></i></span>
								<input type="date" class="form-control" [(ngModel)]="toDate" name="toDate" aria-label="إلى تاريخ">
							</div>
						</div>
					</div>
				</div>
		</div>
		<div *ngIf="!isLoading && !errorMsg && filteredItems.length === 0" class="text-center text-muted py-4">
			<i class="bi bi-inboxes" style="font-size: 2rem;"></i>
			<div class="mt-2" *ngIf="!hasActiveFilters">لا توجد بيانات بعد</div>
			<div class="mt-2" *ngIf="hasActiveFilters">لا توجد نتائج مطابقة لخيارات البحث المحددة</div>
		</div>
		<div class="d-flex align-items-center justify-content-between mb-2">
			<div class="text-muted small">عرض {{displayedItems.length}} من {{sortedItems.length}}</div>
			<div class="d-flex align-items-center gap-2">
				<label class="small text-muted">حجم الصفحة</label>
				<select class="form-select form-select-sm" style="width:auto" [(ngModel)]="pageSize" name="pageSize" (change)="onPageSizeChange()">
					<option [ngValue]="5">5</option>
					<option [ngValue]="10">10</option>
					<option [ngValue]="20">20</option>
					<option [ngValue]="50">50</option>
				</select>
				<div class="btn-group btn-group-sm ms-2">
					<button class="btn btn-outline-secondary" (click)="prevPage()" [disabled]="page===1">&laquo;</button>
					<span class="btn btn-outline-secondary disabled">{{page}} / {{totalPages}}</span>
					<button class="btn btn-outline-secondary" (click)="nextPage()" [disabled]="page===totalPages">&raquo;</button>
				</div>
			</div>
		</div>
		<div class="table-responsive">
			<table class="table table-striped table-bordered align-middle table-sticky table-hover grid-compact">
				<thead class="table-secondary">
					<tr>
						<th class="sticky-col">الإجراءات</th>
						<th class="sortable" (click)="setSort('headNationalId')">رب الأسرة <span class="sort-ind" *ngIf="sortKey==='headNationalId'">{{sortDir==='asc'?'▲':'▼'}}</span></th>
						<th class="sortable" (click)="setSort('memberNationalId')">فرد الأسرة <span class="sort-ind" *ngIf="sortKey==='memberNationalId'">{{sortDir==='asc'?'▲':'▼'}}</span></th>
						<th class="sortable" (click)="setSort('registryNumber')">رقم القيد <span class="sort-ind" *ngIf="sortKey==='registryNumber'">{{sortDir==='asc'?'▲':'▼'}}</span></th>
						<th class="sortable" (click)="setSort('fatherFullName')">اسم الأب <span class="sort-ind" *ngIf="sortKey==='fatherFullName'">{{sortDir==='asc'?'▲':'▼'}}</span></th>
						<th class="sortable" (click)="setSort('subjectFullName')">اسم المعني <span class="sort-ind" *ngIf="sortKey==='subjectFullName'">{{sortDir==='asc'?'▲':'▼'}}</span></th>
						<th class="sortable" (click)="setSort('caseType')">نوع الحالة <span class="sort-ind" *ngIf="sortKey==='caseType'">{{sortDir==='asc'?'▲':'▼'}}</span></th>
						<th class="sortable" (click)="setSort('caseDate')">التاريخ <span class="sort-ind" *ngIf="sortKey==='caseDate'">{{sortDir==='asc'?'▲':'▼'}}</span></th>
						<th class="sortable" (click)="setSort('amountUsd')">المبلغ ($) <span class="sort-ind" *ngIf="sortKey==='amountUsd'">{{sortDir==='asc'?'▲':'▼'}}</span></th>
						<th class="sortable" (click)="setSort('grantsCount')">عدد المنح <span class="sort-ind" *ngIf="sortKey==='grantsCount'">{{sortDir==='asc'?'▲':'▼'}}</span></th>
						<th>صورة</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let e of displayedItems">
						<td class="text-nowrap">
							<button class="btn btn-sm btn-info me-1" (click)="view(e)"><i class="bi bi-eye"></i></button>
							<button class="btn btn-sm btn-primary me-1" (click)="edit(e)"><i class="bi bi-pencil"></i></button>
							<button class="btn btn-sm btn-danger" (click)="remove(e)"><i class="bi bi-trash"></i></button>
						</td>
						<td>{{e.headNationalId}}</td>
						<td>{{e.memberNationalId}}</td>
						<td>{{e.registryNumber}}</td>
						<td>{{e.fatherFullName}}</td>
						<td>{{e.subjectFullName}}</td>
						<td><span [class]="caseTypeBadgeClass(e.caseType)">{{e.caseType}}</span></td>
						<td>{{e.caseDate?.substring(0,10)}}</td>
						<td>{{e.amountUsd | number:'1.2-2'}}</td>
						<td>{{e.grantsCount}}</td>
						<td>
							<img *ngIf="e.imagePath" [src]="apiBase + e.imagePath" class="image-preview" alt="صورة" />
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>


